<template>
  <div>
    <Swiper :data="swiperList" />
    <div class="category-view">
      <div class="top">
        <h3>类目概览</h3>
        <p>Category overview</p>
        <div class="border"></div>
      </div>
      <div class="category-list">
        <div class="category-item" v-for="(item, index) in categoryList" :key="index" @click="goCategory(item)">
          <el-image :src="item.image" lazy fit="cover" class="category-image"></el-image>
          <div class="category-item-name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="project-dynamic gray-bg">
      <div class="top">
        <h3>项目动态</h3>
        <p>Project News</p>
        <div class="border"></div>
      </div>
      <div class="project-dynamic-content">
        <div class="news-content">
          <div class="news-content-item" v-for="(news, i) in dynamicList" :key="i">
            <div :style="'order: '+ (i % 2==0 ? 1: 3)">
              <router-link
                class="text-decoration"
                :to="{ name: 'article', params: { ...news }}"
              >
                <div class="item-img" v-lazy:background-image="news.img || placeholderImg"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">
              <router-link
                class="text-decoration"
                :to="{ name: 'article', params: { ...news }}"
              >
                <h3>{{news.title}}</h3>
              </router-link>
              <p>{{news.brief}}</p>
              <span>{{parseTime(news.createTime, '{y}-{m}-{d}')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="link-btn">
        <router-link to="/dynamic">
          <img src="@/assets/images/link-btn.png" />
        </router-link>
      </div>
    </div>
    <!-- <div class="project-activity">
      <div class="model-name">项目活动</div>
      <div class="model-name-en">Project activities</div>
      <div class="category-list">
        <div class="category-item" v-for="(item, index) in activities" :key="index">
          <el-image :src="item.image" lazy></el-image>
          <div class="category-item-name">{{item.name}}</div>
        </div>
      </div>
      <div class="link-btn">
        <img src="@/assets/images/link-btn.png" />
      </div>
    </div> -->
    <div class="vr-model">
      <div class="top">
        <h3>VR总览</h3>
        <p>VR overview</p>
        <div class="border"></div>
      </div>
      <div class="vr-model-content" id="vrPre">
        <iframe :src="vrSrc" width="100%" height="100%" frameborder="0" />
      </div>
    </div>
    <div class="project-industry gray-bg">
      <div class="top">
        <h3>项目产业</h3>
        <p>Project industry</p>
        <div class="border"></div>
      </div>
      <div class="project-industry-content">
        <Accordion :data="accordionList" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash'
import { placeholderImg } from '@/config'
import { getCarousel, loadYxTitle } from '@/api/api'
import {
  parseTime
} from '@/utils/index'
import Swiper from './components/Swiper2'
import Accordion from '@/components/Accordion'
export default {
  components: {
    Swiper,
    Accordion
  },
  data() {
    return {
      placeholderImg,
      vrOffsetTop: 0,
      // vrSrc: 'https://vr.gdyfpt.com/static/tour.html?id=59',
      vrSrc: '',
      categoryList: [
        {
          name: '景区VR',
          image: require('@/assets/images/vr.jpg'),
          url: 'https://vr.gdyfpt.com/static/tour.html?id=59'
        },
        // {
        //   name: '实时摄像头',
        //   image: require('@/assets/images/overview.png')
        // },
        {
          name: '新闻动态',
          image: require('@/assets/images/news.png'),
          route: '/dynamic'
        }
      ],
      dynamicList: [],
      accordionList: [],
      // activities: [
      //   {
      //     name: '耕耘树艺',
      //     image: require('@/assets/images/overview.png')
      //   },
      //   {
      //     name: '主题餐厅',
      //     image: require('@/assets/images/overview.png')
      //   },
      //   {
      //     name: '户外探险',
      //     image: require('@/assets/images/overview.png')
      //   }
      // ],
      // 幻灯片
      swiperList: []
    }
  },
  mounted() {
    this.vrOffsetTop = $('#vrPre').offset().top - $(window).height()
    window.addEventListener('scroll', this.handleScroll)

    this.loadCarousel()
    this.loadArticles()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    parseTime,
    loadCarousel() {
      getCarousel({
        page: 0,
        size: 20
      }).then(res => {
        var data = res.content.filter(item => {
          return item.isShow == 0
        })
        data = _.sortBy(data, (o) => {
          return o.carouselSort
        })
        // carouselSort
        this.swiperList = data
      })
    },
    loadArticles() {
      loadYxTitle().then(res => {
        var data = res.content.find(item => {
          return item.titleType == 1
        })
        var data2 = res.content.find(item => {
          return item.titleType == 6
        })
        if(data) {
          var list = data.articleTypeList.find(item => {
            return item.articleDetailList
          })
          this.dynamicList = list ? list.articleDetailList.splice(0, 2) : []
        }
        if(data2 && data2.articleTypeList.length > 0) {
          var detailList = data2.articleTypeList[0].articleDetailList
          if(detailList) {
            this.accordionList = detailList
          }
        }
        this.$nextTick(() => {
          this.vrOffsetTop = $('#vrPre').offset().top - $(window).height()
        })
      })
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop > this.vrOffsetTop && !this.vrSrc) {
        this.vrSrc = 'https://vr.gdyfpt.com/static/tour.html?id=59'
      }
    },
    toArticle(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    },
    goCategory(item) {
      if(item.route) {
        this.$router.push({
          path: item.route
        })
      } else if(item.url) {
        window.open(item.url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/styles/color.scss";
  .top {
    h3,
    p {
      text-align: center;
      color: #3c6088;
      font-weight: 400;
      padding: 10px 0;
    }
    h3 {
      font-size: 30px;
    }
    p {
      font-size: 20px;
    }
    .border {
      border-bottom: 1px solid $primary-color;
      width: 15%;
      margin: 0 auto;
    }
  }
  .category-view {
    padding-top: 120px;
  }
  .category-list {
    text-align: center;
    font-size: 0;
    overflow: hidden;
    padding: 80px 0;
    .category-item {
      width: 380px;
      height: 240px;
      display: inline-block;
      margin-right: 30px;
      position: relative;
      cursor: pointer;
      vertical-align: middle;
      &:last-child {
        margin: 0;
      }
      .category-image {
        width: 100%;
        height: 100%;
      }
      .category-item-name {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 42px;
        line-height: 42px;
        background: rgba(57, 57, 57, .6);
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
  .project-dynamic {
    padding: 40px 0 80px;
    .project-dynamic-content {
      padding: 40px 0 100px;
      width: 1200px;
      margin: 0 auto;
    }
  }
  .project-activity {
    padding: 40px 0 80px;
  }
  .vr-model {
    padding: 40px 0 120px;
    .vr-model-content {
      width: 1200px;
      height: 768px;
      margin: 80px auto 0;
    }
  }
  .project-industry {
    padding: 120px 0 180px;
    .project-industry-content {
      width: 1200px;
      height: 572px;
      margin: 0 auto;
      padding-top: 40px;
    }
  }
  .link-btn {
    width: 150px;
    height: 30px;
    cursor: pointer;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .gray-bg {
    background: #F8F8F8;
  }

  //最新资讯
  .news-content {
    width: 1240px;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: center;

    &-item {
      width: 450px;
      display: flex;
      flex-direction: column;

      .item-img {
        width: 390px;
        height: 230px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-origin: content-box;
        margin: 0 auto;
      }
      .el-divider {
        background-color: $primary-color;
        height: 3px;
        .el-divider__text {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          padding: 0px;
          // color: #fff;
          color: $primary-color;
          background: $primary-color;
        }
      }
      .item-content {
        width: 390px;
        height: 230px;
        margin: 0 auto;
        //border: 1px solid paleturquoise;
        h3 {
          font-size: 22px;
          height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p {
          font-size: 15px;
          height: 80px;
          overflow: hidden;
          margin: 10px 0;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          white-space: normal !important;
          word-wrap: break-word;
        }
        span {
          display: block;
          font-size: 14px;
          text-align: end;
        }
        h3,
        p,
        span {
          color: #333333;
        }
      }
    }
  }
  .order {
    order: -1;
  }
  .order-img {
    order: 1;
  }
</style>